import { createContext } from "react";

export const LoginContext = createContext<{
  login: boolean;
  setLogin: React.Dispatch<{ payload: boolean; type: "updateLogin" }>;
}>({ login: false, setLogin: () => { } });

export function loginReducer(
  state: any,
  action: { payload: boolean; type: "updateLogin" }
) {
  if (action.type === "updateLogin") {
    return action.payload;
  } else {
    return state;
  }
}
